import type { HtmlDataConfig } from '@/types';

const htmlData = {
  metaDescription:
    'Jobcenter-Bescheid erhalten? Prüfen Sie jetzt unverbindlich auf hartz4widerspruch.de ob Ihnen mehr Geld zusteht!',
  domainName: 'www.hartz4widerspruch.de',
  trackJsToken: '62fe293f90284011bb0b964f50fb0872',
  trackJsApplicationName: 'jbc-lp',
  funnelType: 'lms-zapier-h4w',
  htmlTitle: 'hartz4widerspruch',
  gtmContainerId: 'W3QNQW9',
  cmpId: '86d3b2ca8165f',
  seo: '<div>Jobcenter-Bescheid erhalten? Prüfen Sie jetzt unverbindlich auf hartz4widerspruch.de ob Ihnen mehr Geld zusteht!</div>',
  convertProjectId: '',
} satisfies HtmlDataConfig as HtmlDataConfig;

export default htmlData;
